export default {
    fund: [{
            "title": "关于私募股权投资的曲线，以下表述错误的是（　　）。",
            "question": "A．曲线反映私募股权投资的收益率随时间变化的轨迹\nB．曲线是因为其轨迹与字母J相似而得名\nC．曲线意味着私募股权投资的收益率通常早期较高，之后逐年走低\nD．私募股权基金在其投资项目的早期阶段，净现金为负数",
            "answer": "C",
            "explain": "本题考查私募股权投资。私募股权基金在其投资项目的前段时期，主要投入资金为主，加上需要支付各种管理费用，因此，在这一阶段，现金净流出，投资者所投资的私募股权基金并不能立即给投资者带来正的收益与回报。曲线意味着，私募股权投资通常并不是一两年内能够获得的回报。投资者在考察其所投资的私募股权基金收益状况时，会画出一条曲线，这条曲线以时间为横轴，以收益率为纵轴，轨迹大致和字母J相似，因此被称为J曲线。"
        },
        {
            "title": "已知名义利率为8%，实际利率为6%，则通货膨胀率为（　　）。",
            "question": "A．2%\nB．8%\nC．6%\nD．5%",
            "answer": "A",
            "explain": "本题考查实际利率与名义利率的关系。实际利率=名义利率-通货膨胀率；所以通货膨胀率=名义利率-实际利率=8%-6%=2%。故本题选A。"
        },
        {
            "title": "下面属于中国结算公司上海分公司全额结算产品的有（　　）。",
            "questions": "I．私募债券转让<br>II．国债买断式回购到期购回<br>III．大宗专场<br>IV．非公开发行优先股转让",
            "question": "A．I、II、III、IV\nB．I、II、III\nC．I、III、IV\nD．I、II、IV",
            "answer": "A",
            "explain": "本题考查场内证券交易结算的方式。中国结算公司上海分公司全额结算产品包括：私募债券转让、申购当日未卖出的跨市场ETF申购涉及的深市组合证券的现金替代、国债买断式回购到期购回、跨境ETF申购、货币ETF申购、大宗专场、不符合净额结算标准的公司债等其他债券交易、专项资产管理计划转让、非公开发行优先股的转让、部分发行类业务（股配债、老股东配售的增发、公司债场内分销）以及可交换公司债换股、深市权证行权。"
        },
        {
            "title": "关于房地产有限合伙，以下表述错误的是（　　）。",
            "question": "A．有限合伙人的投资资金可以在承诺期限截止之前从投资项目中退出\nB．由普通合伙人和有限合伙人组成\nC．普通合伙人对外代表合伙企业，管理和经营项目\nD．有限合伙人以其出资额为限承担有限责任",
            "answer": "A",
            "explain": "房地产有限合伙人将资金提供给普通合伙人，有限合伙人仅以出资份额为限对投资项目承担有限责任，并不直接参与管理和经营项目，普通合伙人通常是房地产开发公司，依赖其具备的专业能力和丰富经验将资金投资于房地产项目当中，之后管理并经营这些项目。有限合伙人的投资资金不可以在承诺期限截止之前从投资项目中退出。"
        },
        {
            "title": "某私募投资经理分析一只信息科技股票，认为虽然其近三个月价格下探，但近一年的稳步上升形态并没有改变，并且走势一直强于大盘和行业指数，近期随着股价下跌，成交量也在萎缩。他认为该股票只要跌幅不超过10%，就可以继续持有。请问他采用的股票分析方法是（　　）。",
            "question": "A．技术分析\nB．行业生命周期分析\nC．相对内在价值分析\nD．基本面分析",
            "answer": "A",
            "explain": "本题考查技术分析。技术分析包括量、价、时、空，通过分析股票的成交量、K线形态、股价走势以及各种指标来指导操作的一种方法。其代表理论有道氏理论和波浪理论。该投资经理分析的是成交量、涨跌幅以及技术图形形态，属于技术分析。"
        },
        {
            "title": "如果市场预测利率会上升，那么下列哪种息票结构最有可能使债券发行人受益（　　）。",
            "question": "A．带有上限的浮动利率债券\nB．通货膨胀联结债券\nC．可回售债券\nD．短期债券",
            "answer": "A",
            "explain": "本题考查浮动利率债券。浮动利率债券的利息在每个支付期期初都会根据基准利率的变化而重新设置。在每期期末支付的利息额是在本支付期期初基准利率的基础上设定的，也就是说，在每个利息支付日利息由上一支付日的基准利率和利差共同决定。另外，有些浮动利息债券的条款中利率存在浮动上限，即浮动利率的顶；有些浮动债券设置了利率浮动的下限，即浮动利率的底。浮动利率债券的顶保护了债券发行人，当市场利率超过浮动利率的顶时，债券发行人最高支付浮动利率顶的利率，从而使债券发行人受益。带有上限的浮动利率债券就是设置了浮动利率的顶，对发行人有利。"
        }, {
            "title": "A公司20X6年1月面向合格投资者完成发行公司债券“X6A债”。发行规模10亿元。因A公司于20X5年亏损4.77亿元，直接导致“X6A债”发行完成后不符合上市条件，并触发了相关条款。最终，投资者于20X6年6月将“X6A债”以约定好的价格（包括本金和期间已发生的利息）卖给了发行人A公司。关于上述案例中的公司债券，其最有可能嵌入的是下列哪一项条款（　　）。",
            "question": "A．结构化条款\nB．可转换条款\nC．可赎回条款\nD．可回售条款",
            "answer": "D",
            "explain": "本题考查债券分类。按嵌入的条款分类，债券可分为可赎回债券、可回售债券、可转换债券、通货膨胀联结债券和结构化债券等。（1）可回售债券为债券持有者提供在债券到期前的特定时段以事先约定价格将债券回售给发行人的权利，约定的价格称为回售价格（通常是面值）。受益人是持有者，保护的是债券持有人，可以降低投资者的价格下跌的风险，所以同样条件下，可回售债券的利息更低，价格更高。本题中“X6A债以约定好的价格（包括本金和期间已发生的利息）卖给了发行人A公司”属于可回售债券。"
        },
        {
            "title": "投资者对于收益的要求存在差异，关于收益率，以下表述正确的是（　　）。",
            "question": "A．如果名义收益率与通货膨胀率相等，那么资产的实际购买力将没有增长\nB．名义收益率能够反映资产的实际购买能力的增长\nC．名义收益率在实际收益率的基础上扣除了通货膨胀的影响\nD．对于长期投资者来说，他们更关注的是名义收益率",
            "answer": "A",
            "explain": "收益率有名义收益率与实际收益率之分。实际收益率在名义收益率的基础上扣除了通货膨胀率的影响。对于长期投资者而言，应该关注的是实际收益率。因为实际收益率能够反映资产的实际购买能力的增长率，而名义收益率仅仅反映了资产名义数值的增长率。如果投资的名义收益率与通货膨胀率相等，那么资产的实际购买能力将没有任何增长。收益目标可以是绝对收益，如年化收益率8%；也可以是相对收益，如沪深300指数收益率+3%。投资者的收益目标须与其风险容忍度相匹配。"
        },
        {
            "title": "有两个资产和，如果资产的预期收益率10%，标准差为4%，资产的预期收益率7%，标准差为2%，假定资产和资产收益率相关系数为-1，当组合标准差为0时，该组合的预期收益率为（　　）。",
            "question": "A．8.5%\nB．7%\nC．8.37%\nD．8%",
            "answer": "D",
            "explain": "本题考查资产组合相关系数。投资组合中的两个资产相关系数为-1的话，那么组合的标准差=组合中两个资产各自的投资权重与标准差乘积之间的差值的绝对值；设证券的投资比例为A，证券的投资比例为B，那么根据组合标准差为0，可知4%×A-2%×B=0，而A+B=1，联立方程组可得A=1/3，B=2/3，该组合的预期收益率=10%×1/3+7%×2/3=8%。"
        },
        {
            "title": "根据自律管理要求，证券登记结算机构为保证业务的正常运行必须采取的措施包括（　　）。",
            "questions": "I．制定完善的风险防范机制和内部控制制度<br>II．建立完善的技术系统，制定由结算参与人共同遵守的技术标准和规范<br>III．建立完善的结算参与人准入标准和风险评估体系<br>IV．建立完善的交易制度，确保交易公平",
            "question": "A．I、II、IV\nB．I、II、III、IV\nC．I、III、IV\nD．I、II、III",
            "answer": "D",
            "explain": "根据自律管理的要求，证券登记结算机构需采取以下措施保证业务的正常运行：一是要制定完善的风险防范机制和内部控制制度；二是要建立完善的技术系统，制定由结算参与人共同遵守的技术标准和规范；三是要建立完善的结算参与人准入标准和风险评估体系；四是要对结算数据"
        },
        {
            "title": "在进行境外投资时，基金管理人需要实时更新和掌握国外的最新监管要求，也要非常熟悉投资法规的规定，这是为了更好的限制以下哪类风险（　　）。",
            "question": "A．投资研究风险\nB．政治风险\nC．税收风险\nD．合规风险",
            "answer": "D",
            "explain": "本题考查跨境投资风险管理。合规风险与公司因未能遵守所有的法律法规而遭受处罚有关。"
        },
        {
            "title": "关于实时处理交收和批量处理交收，以下表述错误的是（　　）。",
            "question": "A．批量处理交收和实时处理交收都可以以全额结算或净额结算方式进行交收\nB．实时处理交收方式下，结算系统实时检查参与者券款情况，只要结算所需条件满足即可进行交收\nC．实时处理交收对市场参与者的流动性要求相对较高\nD．根据结算指令的处理方式，债券结算可以分为实时处理交收和批量处理交收",
            "answer": "A",
            "explain": "本题考查的是交收的方式。根据结算指令的处理方式，债券结算可分为实时处理交收和批量处理交收。实时处理交收是指系统实时检查参与者券款情况，只要结算所需条件满足即可进行券款的交收；而批量处理交收则是将某一时段内满足条件的所有结算在一个特定的时间段内集中进行处理。"
        }, {
            "title": "有的基金合同已经规定投资的行业或风格，这类基金不包括（　　）。",
            "question": "A．行业基金\nB．价值/成长基金\nC．灵活配置基金\nD．大盘/小盘基金",
            "answer": "C",
            "explain": "在行业、风格层面上，有的基金契约已经规定投资的行业或风格，如行业基金、大盘/小盘基金、价值/成长基金等，这些基金的投资范围受到较为严格的限制。"
        },
        {
            "title": "如果当前1年和2年的即期利率分别为7%和8%，那么隐含的远期利率即第2年的1年期利率约为（　　）。如果当前2年和3年的即期利率分别为7%和8%，那么隐含的远期利率即第3年的1年期利率约为（　　）。",
            "question": "A．9%; 10%\nB．1%; 5%\nC．7.5%; 15%\nD．15%; 8%",
            "answer": "A",
            "explain": "本题考查远期利率。根据公式(1+S2)^2=(1+S1)(1+f)，S1表示1年期利率，S2表示2年期利率，f表示远期利率。设第2年的1年期利率远期利率为f1，则有(1+7%)(1+f1)=(1+8%)^2，求解可得f1=9%。设第3年的1年期利率远期利率为f2，则有(1+7%)^2(1+f2)=(1+8%)^3，求解可得f2=10%。"
        },
        {
            "title": "所得免疫策略对养老基金、社保基金等机构投资者具有重要的意义，该策略最重要的特质是满足了投资者（　　）的需要。",
            "question": "A．充足的资金满足预期现金支付\nB．以收益率最大化为首要目标\nC．找到凸性相等的债券组合\nD．资产凸性低于负债凸性",
            "answer": "A",
            "explain": "所得免疫策略保证投资者有充足的资金满足预期现金支付的需要，对于养老基金、社保基金等机构投资者有重要的意义。价格免疫策略使用凸性作为衡量标准，资产凸性高于负债凸性。"
        },
        {
            "title": "对于有效证券市场来说，以下表述错误的是（　　）。",
            "question": "A．通过分析公司公告信息可能获得超额收益\nB．通过分析历史信息可能获得超额收益\nC．通过获得内幕信息可能获得超额收益\nD．通过分析公司所在行业的基本面可能获得超额收益",
            "answer": "B",
            "explain": "有效市场是指证券价格能够充分反映价格历史序列中包含的所有信息。这些历史信息已经被投资者充分消化利用并反映到了证券价格上，因此通过分析历史信息无法获得超额收益。而通过分析公司公告信息、内部消息、行业的基本面信息可能获得超额收益。"
        },
        {
            "title": "以下不属于衍生工具的共同要素的是（　　）。",
            "question": "A．到期日\nB．交割价格\nC．交易单位\nD．票面金额",
            "answer": "D",
            "explain": "本题考查衍生工具。衍生工具要素为：合约标的资产、到期日、交易单位、交割价格、结算。信用衍生工具是指以基础产品所蕴含的信用风险或违约风险为合约标的资产的金融衍生工具，用于转移或防范信用风险。这是20世纪90年代以来发展最为迅速的一类金融衍生工具，主要包括信用互换合约、信用联结票据等。"
        },
        {
            "title": "关于合格境内机构投资者（QDII），以下描述错误的是（　　）。",
            "question": "A．QDII应先向国家外汇管理局申请并获取境外证券投资额度后，向中国证监会申请境外证券投资业务许可文件\nB．QDII应当定期向国家外汇管理局报告其额度使用及资金汇出入情况\nC．QDII应在国家外汇管理局核准的境外证券投资额度内进行投资\nD．QDII应当在托管人处托管账户",
            "answer": "A",
            "explain": "本题考查QDII基金。境内机构投资者在获得证监会颁发的境外证券投资业务许可文件后，应按照有关规定向国家外汇局申请境外证券投资额度，并在国家外汇管理局核准的境外证券投资额度内进行投资。所以“应先向国家外汇管理局申请并获取境外证券投资额度后，向中国证监会申请境外证券投资业务许可文件”顺序错误，应该先向证监会申请文件，再向国家外汇局申请境外证券投资额度。"
        },
        {
            "title": "关于做市商和经纪人，以下表述错误的是（　　）。",
            "question": "A．经纪人的利润主要来自给投资者提供经纪业务的佣金\nB．经纪人在交易中执行投资者的指令，并不参与到交易中\nC．做市商和经纪人的利润来源不同\nD．在报价驱动市场中，经纪人是市场流动性的主要提供者和维持者",
            "answer": "D",
            "explain": "本题考查做市商与经纪人。做市商在报价驱动市场中处于关键性地位，他们在市场中与投资者进行买卖双向交易；经纪人则是在交易中执行投资者的指令，并没有参与到交易中，两者的市场角色不同。两者的利润来源不同——做市商的利润主要来自于证券买卖差价，经纪人的利润则主要来自于给投资者提供经纪业务的佣金；对市场流动性的贡献不同——在报价驱动市场中，做市商是市场流动性的主要提供者和维持者，而在指令驱动市场中，经纪人则承担这一角色。"
        },
        {
            "title": "基金公司的主要利润来源是（　　）。",
            "question": "A．交易佣金\nB．投资收益\nC．基金所持股票分红\nD．基于资产管理规模的管理费",
            "answer": "D",
            "explain": "本题考查基金利润。投资收益是指基金资产运作中因买卖股票、债券、资产支持证券、基金等实现的差价收益，因股票、基金投资等获得的股利收益，以及衍生工具投资产生的相关损益，如卖出或放弃权证、权证行权等实现的损益。具体包括股票投资收益、债券投资收益、资产支持证券"
        }, {
            "title": "假定在某一时期内，一只股票型基金的β值为0.8，收益率标准差为0.4，平均收益率为12.4%，无风险利率为4%，则该股票型基金的夏普比率与特雷诺比率分别为（　　）。",
            "question": "A．0.104、0.21\nB．0.105、0.22\nC．0.22、0.105\nD．0.21、0.105",
            "answer": "D",
            "explain": "本题考查风险调整后收益。夏普比率=(年化收益率-无风险收益率)/标准差=(12.4%-4%)/0.4=0.21，特雷诺比率=(年化收益率-无风险收益率)/β=(12.4%-4%)/0.8=0.105。"
        },
        {
            "title": "以下可以成为可转换债券发行人的是（　　）。",
            "question": "A．拟上市公司\nB．上市公司持股超过20%的股东\nC．上市公司\nD．上市公司控股股东",
            "answer": "C",
            "explain": "本题考查可转债。上市公司发行可转换公司债券作了详细规定。规定中所称的可转换公司债券，是指发行公司依法发行，在一定期间的条件可以转换成股份公司的债券。"
        },
        {
            "title": "当经济处于低迷时期，基金行业也会随之处于低迷状态，该种风险属于基金市场风险的哪一类？（　　）",
            "question": "A．汇率风险\nB．利率风险\nC．购买力风险\nD．经济周期波动风险",
            "answer": "D",
            "explain": "本题考查市场风险。经济发展有一定周期性，由于基金投资的是金融市场已存在的金融工具，所以基金便会追随经济总体趋向而发生变动。当经济处于低迷时期，基金行情也会随之处于低迷状态。2008年金融危机使全球经济处于低迷状态，这种状态同样影响并波及基金市场。"
        },
        {
            "title": "关于最大回撤指标，以下表述错误的是（　　）。",
            "question": "A．该指标能衡量损失的大小和发生频率\nB．指一个时间周期内投资组合收益率回撤幅度的最大值\nC．指定时间区间越长，该指标越不利\nD．同样的市场情况下，最大回撤越小，说明投资组合越抗跌",
            "answer": "A",
            "explain": "本题考查最大回撤。最大回撤测量投资组合在指定区间内从最高点到最低点的回撤（B正确）。最大回撤可以在任何历史区间做测度，用于衡量投资管理人对下行风险的控制能力。指定区间越长，这个指标就越不利，因此在不同的基金之间使用该指标时，应尽量控制在同一个评估期间（C正确），同样的市场情况下，最大回撤越小，说明投资组合越抗跌（D正确），这个指标的缺点是只能衡量损失的大小，而不能衡量损失发生的可能。"
        },
        {
            "title": "对基金拥有的全部资产和负债按一定的原则和方法进行估算，确定基金资产公允价值的过程，称之为（　　）。",
            "question": "A．基金会计核算\nB．基金信息披露\nC．基金利润分配\nD．基金资产估值",
            "answer": "D",
            "explain": "本题考查基金资产估值。基金资产估值是指通过对基金所拥有的全部资产及全部负债按一定的原则和方法进行估算，进而确定基金资产公允价值的过程，故本题选D。"
        },
        {
            "title": "关于证券市场线和资本市场线的比较区别，以下表述错误的是（　　）。",
            "question": "A．资本市场线决定最适合的资产配置点\nB．资本市场线可以运用于有效投资组合\nC．证券市场线用系统性风险（β值）衡量风险\nD．资本市场线的斜率是市场组合的风险溢价",
            "answer": "D",
            "explain": "本题考查资本市场线与证券市场线的区别。两者区别如下：（1）斜率方面：资本市场线的斜率是夏普比率，而证券市场线的斜率是市场组合的风险溢价。（2）风险衡量方面：证券市场线衡量的是系统性风险，用β值衡量，资本市场线用标准差衡量总风险。（3）应用：证券市场线决定资产"
        },
        {
            "title": "A公司为稳定运营的公用事业公司，市场预期其当季每股收益为0.25元，市盈率为8倍，该公司的股票估值可能为（　　）元。",
            "question": "A．8\nB．4\nC．6\nD．2",
            "answer": "A",
            "explain": "本题考查股票价格的计算。根据市盈率=每股价格/每股收益（年化），可知，每股价格=每股收益（年化）×市盈率=0.25×4×8=8元。"
        }, {
            "title": "关于固定收益证券综合电子平台，以下表述错误的是（　　）。",
            "question": "A．交易商在固定收益平台申报卖出固定收益证券的数量，不得超过其账户内可交易余额\nB．固定收益平台的证券现券交易实行净价申报\nC．固定收益平台的交易价格实行涨跌幅限制\nD．交易商T日通过固定收益平台买入的证券，最早T+1日可以卖出",
            "answer": "D",
            "explain": "交易商在固定收益平台申报卖出固定收益证券的数量，不得超过其证券账户内可交易余额。交易商T日买入的固定收益证券，T日可以卖出。在固定收益平台进行固定收益证券现券交易实行净价申报，申报价格变动为0.001元，申报数量单位为1手（1手为1000元面值）。交易价格实行涨跌幅限制，涨跌幅比例为10%。"
        },
        {
            "title": "根据杜邦分析，在假定其它财务数据不变的情况下，以下变化将导致企业净资产收益率下降的是（　　）。",
            "question": "A．销售收入和总资产等额下降\nB．销售收入和净利润等额上升\nC．总资产和净资产等额增加\nD．总资产和总负债等额增加",
            "answer": "C",
            "explain": "本题考查杜邦分析。净资产收益率=销售利润率×总资产周转率×权益乘数=（净利润/销售收入）×（销售收入/总资产）×（总资产/所有者权益），要使净资产收益率下降，那么其它三个指标至少有1个要下降，而当销售收入和总资产等额下降时，销售利润率会上升，总资产周转率不确定，权益乘数会下降，那么它们相乘的结果就是不确定的，销售收入与净利润等额上升，销售利润率会上升，但总资产周转率不确定，所以其结果也不能确定；当总资产和净资产等额增加时，总资产周转率会下降，净资产就是所有者权益，权益乘数由于是大于1的数，所以会下降，另外"
        },
        {
            "title": "关于开放式基金的分红，以下表述错误的是（　　）。",
            "question": "A．每一份基金份额享有同等分配率\nB．可以采用现金分红方式或者分红再投资转换为基金份额的方式\nC．收益分配方案、时间和发放方法都是分红公告中应当包含的主要内容\nD．如果基金份额持有人事先没有做出选择，则基金收益分配默认转为基金份额",
            "answer": "D",
            "explain": "基金分红主要有两种方式：一种是现金分红，一种是红利再投资。根据《证券投资基金运作管理办法》，如果基金份额持有人事先没有做出选择，则基金收益分配默认为现金分红。每一基金份额享有同等分配权，一份基金分红公告中应当包含的内容主要有收益分配方案、时间和发放办法。"
        },
        {
            "title": "关于合格境内机构投资者（QDII）开展境外证券投资业务，以下表述错误的是（　　）。",
            "question": "A．可以委托境外证券服务机构代理买卖证券\nB．应当由境内资产托管机构负责资产托管业务\nC．境内托管人可以委托境外资产托管机构负责境外资产托管，境外托管人因其本身过错、疏忽导致基金财产受损的，由该境外托管人承担责任\nD．可以委托境内基金管理公司在境外设立的分支机构担任投资顾问",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "假设某时期债券违约事件频频发生，致债券交易价呈齐跌，债券基金亏损严重，同时赎回压力剧增，有些债券基金不得不在交易不活跃的情况下，以不适当的价格大量抛售所持债券应对投资者赎回。基金经理认为，随者债券违约成为常态，债券型基金通过购买低评级、高收益率债券提高收益率的道路已经被堵上，未来只能通过购买长久期债券和债券回购等加杠杆的方式来提高收益。债券发行人无力或者不愿支付本息的风险称为（　　）。",
            "question": "A．购买力风险\nB．流动性风险\nC．利率风险\nD．信用风险",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "A公司的税后经营利润为8500万，其实际资本投入总额3亿，当年资本成本中股本成本2000万，债务成本1200万，其经济附加值（EVA）是（　　）。",
            "question": "A．2.47亿\nB．5300万\nC．7300万\nD．6500万",
            "answer": "B",
            "explain": "本题考查经济附加值的计算。经济附加值EVA是基于税后营业净利润和产生这些利润所需资本投入总成本的一种企业绩效财务评价方法。EVA=NOPAT-资本成本，式中：EVA表示经济附加值；NOPAT表示税后经营利润，或称息前税后利润，是指息税前利润EBIT扣除经营所得税；资本成本等于股本成本和债务成本之和。带入数值可以的EVA=8500-（2000+1200）=5300万。"
        },
        {
            "title": "某灵活配置型混合基金，其投资范围内约定股票的投资比例为0~95%，该基金有两位基金经理，一位负责股票的投资，一位负责债券的投资。在实际投资过程中，以下表述错误的是（　　）。",
            "question": "A．该基金的风险水平高于债券型基金，低于股票型基金\nB．该基金的特点是可以根据行情进行大类资产调整，受股票仓位的约束较小\nC．基金经理需要进行大类资产分析，从而决定在股票、债券、现金等大类资产上的配置比例\nD．两位基金经理的投资工作是隔离的，分别单独做投资决定",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于完全复制、抽样复制、优化复制三种指数复制方法，以下表述正确的是（　　）。",
            "question": "A．优化复制所使用的样本股票数目最多\nB．优化复制跟踪误差最大\nC．完全复制跟踪误差最大\nD．抽样复制所使用的样本股票数目最多",
            "answer": "B",
            "explain": "本题考查被动投资。根据市场条件的不同，通常有三种指数复制方法，即完全复制、抽样复制和优化复制。三种复制方法所使用的样本股票的数量依次递减，但是跟踪误差通常依次增加。"
        }, {
            "title": "关于衍生工具结算，以下表述正确的是（　　）。",
            "question": "A．衍生工具交易双方签订的履约保函可以减少违约时非过错方的损失\nB．交易对手风险是指在衍生工具交易中一方违约的风险\nC．衍生工具的结算可以按合约规定在到期日或者到期日之后结算\nD．衍生工具在结算时都可以选择实物交割或者现金结算",
            "answer": "B",
            "explain": "衍生工具结算可以按照合约规定在到期日或到期日之前结算。一些衍生工具在结算时要求实物交割，其他的衍生工具允许计算出净现金盈亏，用现金结算，并非都可以选择实物交割或现金交割。"
        },
        {
            "title": "关于股票型基金的投资策略，以下表述错误的是（　　）。",
            "question": "A．偏好价值风格的基金经理试图寻找相对便宜的股票\nB．合理价格下的成长策略试图寻找成长高于平均水平，同时价格又比较合理的股票\nC．偏好成长风格的基金经理试图选出盈利增长相对最快的股票\nD．无论成长风格还是价值风格，都属于被动投资策略",
            "answer": "D",
            "explain": "被动投资试图复制某一业绩基准，通常是指数的收益和风险。在此策略下，投资经理不会尝试利用基本面分析找出被低估或高估的股票；也不会试图利用技术分析或者数量方法预测市场的总体走势，并根据市场走势相应地调整股票组合。被动投资通过跟踪指数获得基准指数的回报。所以无论是成长风格还是价值风格，投资经理都可能会运用一些技术分析，这是不能确定的事情。"
        },
        {
            "title": "关于债券基金与货币市场基金，以下表述正确的是（　　）。",
            "question": "A．债券基金的投资组合久期越长，面临的利率风险越小\nB．根据目前法规，封闭式债券基金的杠杆率上限为200%\nC．根据目前法规，货币市场基金平均剩余期限的上限为240天\nD．根据目前法规，货币市场基金债券正回购的资金余额不得超过净资产的40%",
            "answer": "B",
            "explain": "本题考查债券基金与货币基金的特点。反映货币市场基金风险的指标有投资组合平均剩余期限、融资比例、浮动利率债券投资情况等。根据目前法规，货币市场基金投资组合的平均剩余期限在每个交易日均不得超过180天。除非发生巨额赎回，货币市场基金债券正回购的资金余额不得超过"
        },
        {
            "title": "公司出现（　　）情况时，可以回购该公司股票。",
            "questions": "I．减少注册资本<br>II．与持有该公司股份的其他公司合并<br>III．公司分立<br>IV．将股票奖励给职工",
            "question": "A．I、II、III\nB．I、III、IV\nC．II、III、IV\nD．I、II、IV",
            "answer": "D",
            "explain": "《公司法》规定，公司除减少注册资本、与持有本公司股份的其他公司合并、将股份奖励给本公司职工外，不得回购本公司股票。"
        },
        {
            "title": "（　　）是由中央银行发行的用于调节商业银行超额准备金的短期债务凭证。",
            "question": "A．银行承兑汇票\nB．短期国债\nC．中央银行票据\nD．商业票据",
            "answer": "C",
            "explain": "本题考查常用货币市场工具。中央银行票据是由中央银行发行的用于调节商业银行超额准备金的短期债务凭证，简称央行票据或央票。"
        },
        {
            "title": "想要了解企业基段时期管理费用的信息，需要查看该企业的（　　）。",
            "question": "A．所有者权益变动表\nB．现金流量表\nC．利润表\nD．资产负债表",
            "answer": "C",
            "explain": "本题考查利润表。利润表由三个主要部分构成：第一部分是营业收入；第二部分是与营业收入相关的生产性费用、销售费用和其他费用；第三部分是利润。利润表也称损益表，主要展示企业的损益账目，反映企业某个会计期间的业务经营状况，直接明了地揭示企业获取利润能力及经营趋势。它反映一定时期（如一个会计季度或会计年度）的总体经营成果，揭示企业财务状况发生变动的直接原因。故本题选择“利润表”。"
        },
        {
            "title": "假定某投资组合收益与市场收益的协方差为正且保持不变，当市场收益的标准差增加时，根据贝塔系数的计算公式，该投资组合贝塔系数将（　　）。",
            "question": "A．不变\nB．先增后减\nC．减少\nD．增加",
            "answer": "C",
            "explain": "本题考查贝塔系数的计算。根据公式：β=Cov/σ^2，其中Cov表示协方差。如果当Cov不变，σ上升时，β下降。"
        }, {
            "title": "个人投资者从基金分配中获得的下列收入，目前需要征收个人所得税的是（　　）。",
            "question": "A．买卖股票差价收入\nB．股利收入\nC．国债利息收入\nD．定期存款利息收入",
            "answer": "B",
            "explain": "本题考查基金税收。个人投资者所得税：（1）个人投资者买卖基金份额获得的差价收入，暂不征收个人所得税。（2）个人投资者从基金分配中获得的股票的股利收入、企业债券的利息收入，由上市公司、发行债券的企业和银行在向基金支付上述收入时，代扣代缴20%的个人所得税。证券投资基金从上市公司分配取得的股票红利所得，按上述《关于上市公司股息红利差别化个人所得税政策有关"
        },
        {
            "title": "以下关于风险指标，以下表述正确的是（　　）。",
            "question": "A．风险是一个事后概念\nB．事后指标通常用来衡量和预测目前组合在将来的表现和风险情况\nC．损失是一个事后概念\nD．损失是一个事前概念",
            "answer": "C",
            "explain": "本题考查风险指标。风险指标可以分成事前和事后两类。事后指标通常用来评价一个组合在历史上的表现和风险情况，而事前指标则通常用来衡量和预测目前组合在将来的表现和风险情况。风险不等同于损失本身，风险是一个事前概念，损失是一个事后概念。"
        },
        {
            "title": "公司的资产在不同证券持有者中的清偿顺序通常为（　　）。",
            "question": "A．优先股股东先于债券持有者，债券持有者先于普通股股东\nB．优先股股东先于普通股股东，普通股股东先于债券持有者\nC．普通股股东先于债券持有者，债券持有者先于优先股股东\nD．债券持有者先于优先股股东，优先股股东先于普通股股东",
            "answer": "D",
            "explain": "本题考查清偿顺序。公司解散或破产清算时，公司的资产在不同证券持有者中的清偿顺序如下：债券持有者先于优先股股东，优先股股东先于普通股股东，故本题选D。"
        },
        {
            "title": "某家公司用部分现金购买了存货，那么该公司流动比率和速动比率的变化关系是（　　）。",
            "question": "A．流动比率变小，速动比率变小\nB．流动比率不变，速动比率不变\nC．流动比率变小，速动比率不变\nD．流动比率不变，速动比率变小",
            "answer": "D",
            "explain": "本题考查财务比率分析。流动性比率是用来衡量企业的短期偿债能力的比率，主要有流动比率和速动比率两种。重点关注的是企业的流动资产和流动负债。相对于其他流动资产来说，存货的流动性较差。本题中现金购买存货，流动资产中现金减少但是存货增加，所以流动资产不变。流动"
        },
        {
            "title": "关于银行间债券市场全额结算，以下表述正确的是（　　）。",
            "question": "A．全额结算要求指定时间段内所有的结算都顺利进行，如果有某个参与者无法进行结算，则会对其他参与者的结算带来影响，甚至给整个市场带来较大的系统性风险\nB．全额结算可以分为中央对手方净额结算和非中央对手方净额结算两种模式\nC．全额结算过程中，结算机构会参与到结算中去，并对结算完成进行担保\nD．全额结算会对频繁交易的做市商有较高的资金需求，其资金负担较大，结算成本较高",
            "answer": "D",
            "explain": "本题考查银行间债券市场的结算。全额结算要求指定时间段内所有的结算都顺利进行，如果有某个参与者无法进行结算，则会对其他参与者的结算需求影响，甚至给整个市场带来较大的系统性风险。在多边净额结算中，按照结算机构在结算中是否担当中央对手方，可以分为中央对手方净额结算和非中央对手方净额结算两种模式。"
        },
        {
            "title": "根据资本资产定价模型，市场价格偏高的证券将会（　　）。",
            "question": "A．位于证券市场线下方\nB．位于资本市场线下方\nC．位于证券市场线上方\nD．位于资本市场线上方",
            "answer": "A",
            "explain": "本题考查证券市场线的应用。位于证券市场线上方的证券期望报酬率高于必要的报酬率，这时证券价格被低估；相反，位于证券市场线下方的证券期望报酬率低于必要报酬率，折现之后的价格会被高估。"
        },
        {
            "title": "关于期权合约的常见类型，以下表述正确的是（　　）。",
            "question": "A．期权在有效期内，随着时间的变化，实值期权、平价期权、虚值期权之间不能相互转化\nB．欧式期权可以提前或推迟执行\nC．看涨期权又称买入期权\nD．美式期权的期权费通常要比欧式期权的期权费低一些",
            "answer": "C",
            "explain": "本题考查期权。看涨期权是指赋予期权的买方在事先约定的时间以执行价格从期权卖方手中买入一定数量的标的资产的权利的合约，又称买入期权。期权在有效期内，随着时间的变化，实值期权、平价期权、虚值期权之间会相互转化；期权按行权时间分类分为欧式期权、美式期权、百"
        }, {
            "title": "下列基金公司投资交易环节中，由交易部负责的是（　　）。",
            "question": "A．构建投资组合\nB．执行交易指令\nC．绩效评估与组合调整\nD．形成投资策略",
            "answer": "B",
            "explain": "基金公司通常设有交易室，通过电子交易系统完成交易并记录每日投资交易情况，在交易过程中严格执行相关规定，并利用技术手段避免违规行为的出现。为提高交易效率和有效控制基金管理中交易执行的风险，基金采取集中交易制度，即基金的投资决策与交易执行职能分别由基金经理与基金交易部门承担。基金交易部属于基金公司的核心保密区域，执行最严格的保密要求。"
        },
        {
            "title": "以下选项中不属于股票价格指数的编制方法的是（　　）。",
            "question": "A．几何平均法\nB．移动平均法\nC．算术平均法\nD．加权平均法",
            "answer": "B",
            "explain": "目前股票价格指数编制的方法主要有三种，即算术平均法、几何平均法和加权平均法。"
        },
        {
            "title": "关于基金场内证券交易和结算涉及的费用，以下表述错误的是（　　）。",
            "question": "A．佣金的收费标准因交易品种、交易所的不同而有所差异\nB．为防止恶性竞争，我国证券投资基金的交易佣金实行最低底线和向上浮动制度\nC．过户费属于中国结算公司的收入\nD．为保证税率，简化缴款手续，我国证券交易的印花税实行代扣代缴，最后由中国结算公司统一向征税机关缴纳",
            "answer": "B",
            "explain": "本题考查场内证券交易结算涉及的费用。佣金是投资者在委托买卖证券成交后按成交金额一定比例支付的费用，是证券经纪商为客户提供证券代理买卖服务收取的费用。佣金的收费标准因交易品种、交易场所的不同而有所差异。"
        },
        {
            "title": "基于全球经济向好的判断，张某计划进行大宗商品投资，他不希望花费运输和储存成本，同时希望在行情变化时通过交易所将投资资产卖出。张某可以选择的投资方式包括（　　）。",
            "questions": "I．购买大宗商品实物<br>II．购买大宗商品相关股票<br>III．购买大宗商品期货合约<br>IV．购买某银行发行的大宗商品结构化产品",
            "question": "A．I、III\nB．II、IV\nC．II、III\nD．I、IV",
            "answer": "C",
            "explain": "张某可以选择的投资方式包括购买大宗商品相关股票和购买大宗商品期货合约。"
        },
        {
            "title": "关于基金资产中利息收入的核算方式，以下表述正确的是（　　）。",
            "question": "A．银行存款利息收入到期结算时计提\nB．股息和红利确认利息收入\nC．回购利息收入首期结算时计提\nD．清算备付金利息收入按日计提",
            "answer": "D",
            "explain": "利息主要包括债券的利息、银行存款利息、清算备付金利息、回购利息等。各类资产利息均应按日计提，并于当日确认为利息收入。权益核算是指与基金持有证券的上市公司有关的、所有涉及该证券权益变动并进而影响基金权益变动的事项，包括发行新股、发放股息和红利、配股等公司行为的核算。"
        },
        {
            "title": "除普通股外，上市公司还发行了其他证券，以下证券风险收益特征最接近债券融资的是（　　）。",
            "question": "A．存托凭证\nB．累计优先股\nC．非累计优先股\nD．认购权证",
            "answer": "B",
            "explain": "优先股一般享有固定的股利，具备债券的特性。按照股利是否可以累计，优先股分为累计优先股和非累计优先股。累计优先股指当期股利未支付的，可以累计到以后会计年度一次性支付，好比债券的到期一次性付清。非累计优先股指当期股利未支付的，不再累计到以后会计年度，以后也不再补发。"
        }, {
            "title": "以下指数中不属于国内股票价格指数的是（　　）。",
            "question": "A．上证180指数\nB．金融时报股价指数\nC．沪深300指数\nD．深证综合股票价格指数",
            "answer": "B",
            "explain": "金融时报股价指数是英国的股价指数，其他三项均属于国内，此外上证50指数，中证500指数等都是国内股价指数。"
        },
        {
            "title": "基金公司投资交易流程不包括（　　）。",
            "question": "A．基金销售推介\nB．绩效评估与组合调整\nC．风险控制\nD．执行交易指令",
            "answer": "A",
            "explain": "本题考查投资交易流程。基金公司投资交易流程包括形成投资策略、构建投资组合、执行交易指令、绩效评估与组合调整、风险控制等环节。"
        },
        {
            "title": "根据我国银行间债券市场结算代理制度，开展结算代理业务的金融机构法人，需经（　　）批准。",
            "question": "A．中国证券业协会\nB．中国人民银行\nC．中国证券投资基金业协会\nD．中国证券监督管理委员会",
            "answer": "B",
            "explain": "本题考查场内证券交易结算的方式。结算代理制度，是指经中国人民银行批准可以开展结算代理业务的金融机构法人，受市场其他参与者的委托，为其办理债券结算业务的制度。"
        },
        {
            "title": "以下不符合交易指令在基金公司内部执行流程的是（　　）。",
            "question": "A．交易员选择合适时机完成交易\nB．基金经理通过交易系统指定自己熟悉的交易员完成所下达的交易指令\nC．交易员可通过交易系统查看交易成交情况\nD．交易室负责人审核投资指令的合法合规性，并分发给交易员",
            "answer": "B",
            "explain": "基金经理通过交易系统向交易室下达交易指令，而非下达给自己熟悉的交易员。交易室负责人审核投资指令的合法合规性，并分发给交易员。交易员可以选择合适时机完成交易，也可以通过交易系统查看交易成交情况。"
        },
        {
            "title": "A基金当日资产净值为105亿元，前一日资产净值是100亿元，年管理费率1.5%，年托管费率0.25%，当年天数365天，则当天计提基金托管费为（　　）万元。",
            "question": "A．41和6.85\nB．43和7.2\nC．42和7\nD．40和6.66",
            "answer": "A",
            "explain": "本题考查基金费用项目。目前，我国的基金管理费、基金托管费及基金销售服务费均是按前一日基金资产净值的一定比例逐日计算。计算方法为H=ER/当年实际天数，式中H表示每日计提的费用；E表示前一日的基金资产净值；R表示年费率。所以管理费=100（万元）；托管费=100亿*0.25%/365=6.85（万元）。"
        },
        {
            "title": "评估基金的业绩时需要考虑的方面包括（　　）。",
            "questions": "I．计算绝对收益<br>II．计算相对收益<br>III．计算风险调整后收益<br>IV．进行业绩归因",
            "question": "A．I、II、III、IV\nB．II、III、IV\nC．I、II、IV\nD．I、II、III",
            "answer": "A",
            "explain": "评估基金的业绩时需要考虑的方面包括计算绝对收益、计算相对收益、计算风险调整后收益、进行业绩归因。"
        },
        {
            "title": "关于远期和期货合约的比较，下列说法正确的是（　　）。",
            "question": "A．远期合约可以在场外进行交易\nB．远期合约都是标准化合约\nC．远期合约的流动性要好于期货合约\nD．远期合约的履约信用风险小于期货合约",
            "answer": "A",
            "explain": "本题考查远期合约。远期合约的流动性要次于期货合约。期货合约都是标准化合约，远期合约不是标准化合约，远期合约可以在场外进行交易。远期合约的履约信用风险大于期货合约。"
        }, {
            "title": "关于债券的到期收益率，以下表述正确的有（　　）。",
            "questions": "I．到期收益率等同于内部收益率<br>II．到期收益率是债券的年利息收入与当前债券市场价格的比率<br>III．用到期收益率作为贴现率，计算出的债券内在价值等同于当前债券市场价格<br>IV．到期收益率相当于按照市场价格买入并持有到期债券获得的年平均收益率",
            "question": "A．I、III、IV\nB．I、II、III\nC．II、III、IV\nD．I、II、IV",
            "answer": "A",
            "explain": "本题考查到期收益率。到期收益率是指将债券持有到偿还期所获得的收益，包括到期的全部利息。到期收益率又称最终收益率，是投资购买国债的内部收益率，即可以使投资购买国债获得的未来现金流量的现值等于债券当前市价的贴现率。它相当于投资者按照当前市场价格购买并且持有到期债券获得的年平均收益率。"
        },
        {
            "title": "2019年4月5日（星期五）至2019年4月7日（星期日）是清明节假期，为了享有普通货币市场基金在该清明假期间的收益，投资者可以在以下哪些时点申购（　　）。",
            "questions": "I．2019年4月2日（星期二）上午10:00<br>II．2019年4月3日（星期三）上午10:00<br>III．2019年4月4日（星期四）上午10:00<br>IV．2019年4月5日（星期五）上午10:00",
            "question": "A．I、II\nB．I、II、III\nC．I\nD．I、II、III、IV",
            "answer": "A",
            "explain": "本题考查货币市场基金的申购时间。货币市场基金在假期前一个工作日结束前申购，可以享有假期收益。"
        },
        {
            "title": "某种零息债券的面额为100元，贴现率为4%，到期时间180天，用DCF估值法计算，内在价值最接近（　　）元。",
            "question": "A．98\nB．98.69\nC．99\nD．99.05",
            "answer": "A",
            "explain": "本题考查债券估值。DCF估值法就是现金流贴现法。V=M*(1-t/360*r)，其中V为债券内在价值，M为面值，t为时间，r为年化市场利率。由题可知，V=100*(1-180/360*4%)，因此V=98元。"
        },
        {
            "title": "关于最优组合，以下表述错误的是（　　）。",
            "question": "A．在标准差为横坐标、期望收益为纵坐标的平面上，风险厌恶程度高的投资者其最优组合在风险厌恶程度低的投资者的左下方\nB．最优组合的点位于有效前沿\nC．最优组合是在任一无差异曲线与有效前沿的切点\nD．最优组合是投资者可以实际选择并获得最大效用的点",
            "answer": "C",
            "explain": "本题考查最优投资组合。使投资者效用最大化的是无差异曲线和有效前沿相切的点所代表的投资组合，这一组合成为最优组合。投资者按照这一组合进行投资可以获得最大的投资效用。因为这个点在有效前沿上，因此它是投资者可以实际选择的点；而它又是所有与有效前沿相交的无差异曲线中位于最上方的无差异曲线上的点，因此它又是投资者可以获得最大效用的点。风险厌恶程度不同的投资者，其切点位置也不同。在标准差"
        },
        {
            "title": "名义利率是指包含对（　　）补偿的利率。",
            "question": "A．即期收益率\nB．通货膨胀\nC．到期收益率\nD．无风险利率",
            "answer": "B",
            "explain": "本题考查实际利率与名义利率的关系。名义利率是指包含对通货膨胀补偿的利率，是央行或其它提供资金借贷的机构所公布的未调整通货膨胀因素的利率，即利息（报酬）的货币额与本金的货币额的比率。即指包括补偿通货膨胀（包括通货紧缩）风险的利率。"
        },
        {
            "title": "一家制作型企业所发行的固定利率债券被某评级机构提高了评级，该债券的价格也相应有所上升，这一价格的上升最可能是由于下列哪种原因引起的（　　）。",
            "question": "A．该债券流动性风险的提高\nB．该债券再投资风险的降低\nC．该债券信用风险的降低\nD．该债券提前赎回风险的提高",
            "answer": "C",
            "explain": "本题考查信用利差。评级提高，降低信用风险，提升债券价格。"
        }, {
            "title": "某公司2015年度资产负债表中，货币资金为600亿元，应收账款为200亿元，应收票据为200亿元，无形资产为50亿元，长期股权投资为20亿元，则应计入流动资产的金额为（　　）亿元。",
            "question": "A．1070\nB．1000\nC．1050\nD．1020",
            "answer": "B",
            "explain": "本题考查资产负债表内容。资产=流动资产+非流动资产。流动资产，指企业可以在一年内或者超过一年的一个营业周期内变现或者运用的资产，主要包括：货币资金、现金等价物、应收账款、应收票据、预付款、存货、以及其他流动资产；非流动资产主要包括：固定资产、无形资产、长期股权投资以及其他非流动资产，注意一年内到期的长期资产要归入流动资产。"
        },
        {
            "title": "以下不属于显性成本的是（　　）。",
            "questions": "I．过户费<br>II．对冲费用<br>III．买卖价差<br>IV．印花税",
            "question": "A．I、II、IV\nB．II、III\nC．I、IV\nD．III",
            "answer": "B",
            "explain": "显性成本（直接成本或价外成本）是不包含在交易价格以内的费用支出，按照收费主体划分，包含经纪商佣金、税费、交易所规费/结算所规费三个主要部分，包括我国证券交易所向投资者收取证券交易经手费、监管费和印花税；证券交易结束后还需要支付给证券登记结算机构一定费用，这部分费用称为过户费；交易技术供应商的收费等。"
        },
        {
            "title": "下列关于个人投资者的表述错误的是（　　）。",
            "question": "A．投资需求主要由个人需求决定，和个人家庭状况没有关系\nB．个人投资者的家庭负担越重，投资者越偏向稳健投资策略\nC．个人投资者是基金投资群体的重要组成部分\nD．个人投资者的就业状况会对其投资需求产生影响",
            "answer": "A",
            "explain": "本题考查个人投资者。个人投资者的家庭状况也会影响其投资需求。家庭负担越重，则可投资的资源越少，投资者越偏向于稳健的投资策略。"
        },
        {
            "title": "2018年初，某QDII基金将人民币换成美元，投资于美国市场。假设当年该基金以美元计价盈亏平衡，人民币相对美元贬值，年末投资者赎回收到人民币，不考虑费用影响，投资者的损益情况是（　　）。",
            "question": "A．亏损\nB．盈利\nC．不确定\nD．不变",
            "answer": "B",
            "explain": "本题考查跨境投资风险管理。跨境投资风险管理：（1）通过不同国家地区的资产组合能分散风险。（2）多币种投资和汇率避险操作相结合。QDII基金投资于全球多币种市场，不仅可有效降低投资单一市场所面临的汇率风险，还可分享比人民币走势更好的货币对人民币升值带来的好处。年初投资美元债券，盈亏平衡，年末美元升值，收益转化成人民币后，收益增多。"
        },
        {
            "title": "以下可以为企业提供短期资金融通手段的货币市场工具是（　　）。",
            "questions": "I．商业票据<br>II．银行承兑汇票<br>III．短期融资券<br>IV．短期融资券",
            "question": "A．I、II、IV\nB．II、III、IV\nC．I、II、III\nD．I、II、III、IV",
            "answer": "A",
            "explain": "本题考查货币市场工具。货币市场工具主要包括现金，期限在1年以内（含1年）的银行存款、债券回购、中央银行票据、同业存单、剩余期限在397天以内（含397）的债券、非金融企业债务融资工具、资产支持证券，以及中国证监会、中国人民银行认可的其他具有良好流动性的其他货币"
        },
        {
            "title": "关于期货市场中投机者，以下表述正确的是（　　）。",
            "question": "A．投机者增加了期货市场的流动性，使得套期保值能顺利执行\nB．没有投机者的话，期货市场的运行会更为顺畅\nC．投机者增加了期货市场的风险，会影响套期保值的正常运转\nD．投机者的存在对于套期保值的投资人几乎没有影响",
            "answer": "A",
            "explain": "本题考查投机者的作用。投机者是期货市场的重要组成部分，是期货市场必不可少的润滑剂。投机交易增强了市场的流动性，承担了套期保值交易转移的风险，是期货市场正常运营的保证。如果没有这些风险承担者，只有套期保值者参与期货交易，那么只有在买入套期保值者和卖出套期保值者的交易数量完全相等时，交易才能成立，风险才能得以成功转移。但从实际来看，买入套期保值者和卖出套期保值者之间的不平衡是经常发生的。投机者的加入恰好能抵消这种不平衡，促使套期保值交易活动的实现。因此，正是因为有投机者参与，套期保值才能顺利进行。故本题选A。"
        }, {
            "title": "对于股票型基金，业内比较常用的业绩归因方法是（　　）。",
            "question": "A．夏普比率\nB．Brinson模型法\nC．特雷诺比率法\nD．詹森比率法",
            "answer": "B",
            "explain": "本题考查相对收益归因。相对收益归因，则是通过分析基金与比较基准在资产配置、证券选择等方面的差异，来找出基金跑赢或跑输业绩比较基准的原因。对于股票投资组合进行相对收益归因分析，最常用的是Brinson模型。股票投资经理在考虑如何战胜指数时，可以进行各种不同资产配置或挑选不同的证券。绝对收益归因是考察各个因素对基金总收益的贡献，其本质是对基金总收益的分解。"
        },
        {
            "title": "关于衍生金融工具，以下表述错误的是（　　）。",
            "question": "A．期权合约和利率互换合约被称为单边合约\nB．期权合约和远期合约以及期货合约的不同在于其损益的不对称性\nC．信用违约互换合约使买方可以对卖方行使某种权利\nD．远期合约和期货合约有时被称作远期承诺",
            "answer": "A",
            "explain": "本题考查远期合约、期货合约、期权合约和互换合约的区别。远期合约、期货合约和大部分互换合约都包括买卖双方在未来应尽的义务，因此，它们有时被称作远期承诺或者双边合约。与此相反，期权合约和信用违约互换合约只有一方在未来有义务，因此被称作单边合约。期权合约和信用违约互换合约使买方可以对卖方行使某种权利。当情形对自己有利或者特定条件被满足时，买方可以行权。期权合约与远期合约以及期货合约的不同之处是它的损益的不对称性。"
        },
        {
            "title": "关于银行间债券市场中“公开市场一级交易商制度”，以下表述正确的是（　　）。",
            "question": "A．公开市场一级交易商是银行间交易商协会确定的\nB．公开市场一级交易商不能参加二级市场交易\nC．公开市场一级交易商制度是为配合中国人民银行货币政策的实现而设立的\nD．公开市场一级交易商仅与投资者进行债券交易",
            "answer": "C",
            "explain": "本题考查银行间债券市场。公开市场一级交易商制度，是指中国人民银行根据规定选符合条件的债券二级市场参与者作为中国人民银行的对手方，与之进行债券交易，从而配合中国人民银行货币政策目标的实现。"
        },
        {
            "title": "关于股票型基金，以下表述错误的是（　　）。",
            "question": "A．基金收益率波动程度越小，基金的风险越低\nB．分散投资不能降低投资的系统性风险\nC．若服从正态分布，则基金收益率落入平均值左右2个标准差范围的概率是96%\nD．通常按月计算基金收益率的波动程度，衡量标准可以选择标准差",
            "answer": "C",
            "explain": "若服从正态分布，则基金收益率落入平均值左右2个标准差范围的概率是95%。股票基金是高风险的投资基金品种，相对于混合基金、债券基金与货币基金，股票基金的预期收益与风险皆为最高。股票基金通过分散投资可以大大降低个股投资的非系统性风险，可以设置个股最高比例来控制个股风险，实现风险分散化。股票基金主要投资于股票，其净值变动与股票市场变化相关度较高。常用来反映股票基金风险的指标有标准差、贝塔系数、持股集中度、行业投资集中度、持股数量等。通常使用的大小衡量一只股票基金面临的市场风险的大小。"
        },
        {
            "title": "关于货币的时间价值，以下表述不正确的是（　　）。",
            "question": "A．一定金额的资金必须注明其发生的时间，才能确切的表达其准确的价值\nB．两笔金额相等的资金，如果发生在不同的时期，其实际价值量也是相等的\nC．货币的时间价值是指货币随着时间的推移而发生的增值\nD．货币的时间价值意味着同样数量的资金现在的通常比未来的价值大",
            "answer": "B",
            "explain": "本题考查货币时间价值。货币时间价值是指货币随着时间的推移而发生的增值。由于货币具有时间价值，即使两笔金额相等的资金，如果发生在不同的时期，其实际价值量也是不相等，一定金额的资金必须注明其发生时间，才能确切地表达其准确的价值。"
        },
        {
            "title": "以下选项中，不能用来衡量债券基金流动性风险的指标是（　　）。",
            "question": "A．短期可变现资产比例\nB．现金比例\nC．持仓集中度\nD．债券换手率",
            "answer": "D",
            "explain": "衡量债券基金流动性风险的指标包括持仓集中度、流通受限制资产、现金比例、短期可变现资产比例、区间可变现资产比例、可变现资产变现天数等。不包括债券换手率，债券换手率只能反映债券的流动性强弱，但不能作为债券基金的流动性风险指标。"
        },
        {
            "title": "关于战略性资产配置和战术性资产配置，以下说法错误的是（　　）。",
            "question": "A．战术性资产配置的周期较短\nB．战术性资产配置的前提是建立在组合管理人员具备优秀的择时能力基础上的\nC．战略性资产配置是为了满足投资者风险与收益目标所做的长期资产的配比\nD．战略性资产配置不考虑投资者的风险与收益目标",
            "answer": "D",
            "explain": "本题考查资产配置。战略性资产配置是为了满足投资者风险与收益目标所做的长期资产的配比，是根据投资者的风险承受能力，对资产做出一种事前的、整体的、最能满足投资者需求的规划和安排，是反映投资者的长期投资目标和政策，确定各主要大类资产的投资比例，建立最佳长期投资组合。"
        }, {
            "title": "某股票发行时的票面价值为10元/股，实际发行价格为15元/股，共发行1亿股。以下表述正确的是（　　）。",
            "question": "A．该股票发行产生10亿元资本公积\nB．该股票发行所筹集的股本为15亿元\nC．该股票发行所募集的股本为10亿元\nD．该股票发行产生15亿元资本公积",
            "answer": "C",
            "explain": "本题考查股票发行类型。发行价格高于面值称为溢价发行，募集的资金大于股本的总和，其中等于面值总和的部分记入股本，超额部分记入资本公积。本题中面值10元，发行价格15元，超过面值的部分5元*1亿计入资本公积，全部面值部分10*1亿计入股本。"
        },
        {
            "title": "下列选项中，不属于基金暂停估值情形的是（　　）。",
            "question": "A．基金投资所涉及的证券交易所因法定节日休市\nB．基金管理人认为属于紧急事故，会导致基金管理人不能出售基金资产\nC．基金管理人认为可能会导致大量赎回\nD．基金投资所涉及的证券交易所因台风暂停营业",
            "answer": "C",
            "explain": "本题考查暂停估值。当基金有以下情形时，可以暂停估值：（1）基金投资所涉及的证券交易所遇法定节假日或因其他原因暂停营业时；（2）因不可抗力或其他情形致使基金管理人、基金托管人无法准确评估基金资产时；（3）占基金相当比例的投资品种的估值出现重大转变，而基金管理人为保障投资人的利益已决定延迟估值；（4）如出现基金管理人认为属于基金事故的任何情况，会导致基金管理人不能出售或评估基金资产的："
        },
        {
            "title": "有关银行间债券市场买断式回购业务，以下表述中错误的是（　　）。",
            "question": "A．目前买断式回购的期限最长不得超过91天\nB．在买断式回购期内，债券归逆回购方所有\nC．买断式回购的担保债券可以为单一券种或多个券种\nD．买断式回购期间，交易双方不得换券、现金交割和提前赎回",
            "answer": "C",
            "explain": "买断式回购期间资金融出方不仅可获得回购期间融出资金的利息收入，亦可获得回购期间债券的所有权和使用权。在买断式回购期内，该债券归逆回购方所有，回购方可以使用该笔债券，只要到期有足够的同种债券返还给正回购方即可。买断式回购的期限最长不得超过91天，具体期限由交易双方确定。买断式回购的结算债券及用于担保的债券均应为单一券种，可选择的债券券种范围与现券买卖相同。买断式回购期间，交易双方不得换券、现金交割和提前赎回。"
        },
        {
            "title": "已知某基金近两年来总收益为44%，那么应用几何平均收益率计算的该基金近两年的年化收益为（　　）。",
            "question": "A．20%\nB．21%\nC．19%\nD．22%",
            "answer": "A",
            "explain": "本题考查绝对收益。设第一年收益率为R1，第二年收益率为R2，则（1+R1）*（1+R2）-1=44%，可以推出（1+R1）*（1+R2）=1+44%=1.444,几何平均=[（1+R1）*（1+R2）*...*（1+Rn）]^(1/n)-1=[（1+R1）*（1+R2）]^0.5-1=（1.44^0.5)-1=20%。其中R1为第1年收益率，R2为第2年收益率，n为期数。"
        },
        {
            "title": "出现安全投资转移现象时，以下表述正确的是（　　）。",
            "questions": "I．信用利差扩大<br>II．经济处于收缩或下滑状态<br>III．低风险的政府部门债券价格上涨",
            "question": "A．I、II、III\nB．I、II\nC．II、III\nD．I、III",
            "answer": "A",
            "explain": "本题考查安全投资转移。信用利差扩大、经济处于收缩或下滑状态、低风险的政府部门债券价格上涨"
        },
        {
            "title": "下列表述中，不属于现金流量表特点的是（　　）。",
            "question": "A．反映公司资产负债平衡关系\nB．评价企业偿还债务、支付投资利润的能力\nC．反映企业的现金流量，评价企业未来产生现金净流量的能力\nD．分析净收益与现金流量间的差异，并解释差异产生的原因",
            "answer": "A",
            "explain": "本题考查现金流量表。资产负债表反映公司资产负债的平衡关系，而现金流量表是反映一定时期内（如月度、季度或年度）企业经营活动、投资活动和筹资活动对其现金及现金等价物所产生影响的财务报表。它能反映企业的现金流量，评价企业未来产生现金净流量的能力，也能评价企业偿债及投资能力的大小，而且还可以分析净收益与现金流量间的不同，并展现差异产生的原因。"
        }, {
            "title": "以下选项中，不属于基金管理人在估值业务中应承担的责任的是（　　）。",
            "question": "A．建立估值委员会，健全估值决策体系\nB．完善相关风险监测、控制和报告机制\nC．制定基金估值和份额净值计价的业务管理制度，明确基金估值的程序和技术\nD．制定基金估值指引",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "下列与基金相关的费用中，逐日计提按月支付的是（　　）。",
            "question": "A．证管费\nB．经手费\nC．过户费\nD．销售服务费",
            "answer": "D",
            "explain": "本题考查基金费用计提。目前，我国的基金管理费、基金托管费及基金销售服务费均是按前一日基金资产净值的一定比例逐日计提，按月支付。"
        },
        {
            "title": "相对估值法常见的估值比率包括（　　）。",
            "questions": "I．市盈率<br>II．市净率<br>III．贴现率<br>IV．企业价值倍数",
            "question": "A．I、II\nB．I、II、IV\nC．I、II、III\nD．I、II、III、IV",
            "answer": "B",
            "explain": "本题考查相对估值法估值。相对估值法是选用一家上市公司的市盈率、市净率、市销率、市现率等指标与其竞争者进行对比，以决定该公司价值的方法。包括：市盈率、市净率、市销率、市现率以及企业价值倍数模型。"
        },
        {
            "title": "关于交易所发行未上市品种的业务描述，在上市前通常采用成本法估值的是（　　）。",
            "question": "A．某基金产品参与股票B的公开增发新股，获配1000股\nB．某基金产品参与交易所债券发行，获配10000元面值金额\nC．某基金产品参与股票C的配股，获配1000股\nD．某基金产品参与股票A的首次公开发行，获配1000股",
            "answer": "D",
            "explain": "1.交易所发行未上市品种的估值。（1）首次发行未上市的股票和权证，采用估值技术确定公允价值，在估值技术难以可靠计量公允价值的情况下按成本计量。（2）送股、转增股、配股和公开增发新股等发行未上市股票，按交易所上市的同一股票的市价估值。（3）交易所发行未上市或未挂牌转让的债券，在存在活跃市场的情况下，应以活跃市场上未经调整的报价作为计量日的公允价值；活跃市场报价未能代表计量日公允价值的情况下，应对市场报价进行调整以确认计量日的公允价值；对于不存在市场活动或市场活动很少的情况下，则应采用估值技术确定其公允价值。"
        },
        {
            "title": "下列关于基金估值原则中对于使用可观察输入值和不可观察输入值的说法，错误的是（　　）。",
            "question": "A．对于不存在活跃市场的投资品种进行估值时，应当优先使用可观察输入值\nB．当获得相关资产或者负债的可观察输入值不实际可行的情况下，可以使用不可观察输入值\nC．存在活跃市场且能获得相关资产的报价，但具备不同特征的，可直接使用不可观察输入值\nD．当无法取得相关资产或者负债的可观察输入值的情况下，可以使用不可观察输入值",
            "answer": "C",
            "explain": "本题考查基金资产估值的原则及方法。（1）存在活跃市场且能获得相关资产的报价，但具备不同特征的，应以影响资产或负债的公允价值为基础，并在估值技术中考虑不同特征因素的影响，而不是“优先使用可观察输入值”；"
        },
        {
            "title": "某机构投资者7月4日买入A基金1000份，成交价格1.1元，卖出B基金5000份，成交价格2元，不考虑其它交易费用的前提下，该机构投资者当日需支付的印花税是（　　）元。",
            "question": "A．11\nB．10\nC．21\nD．0",
            "answer": "D",
            "explain": "本题考查投资者买卖基金产生的税收。目前对印花税的规定：（1）机构投资者买卖基金份额暂免征印花税。（2）个人投资者买卖基金份额暂免征印花税。（3）对香港市场个人投资者通过基金互认买卖、继承、赠予内地基金份额，按照内地现行税制规定，暂不征收印花税。（4）对内地个人投资者通过基金互认买卖、继承、赠予香港基金份额，按照香港特别行政区现行印花税税法规定执行。"
        }, {
            "title": "关于债券基金，以下表述错误的是（　　）。",
            "questions": "I．利率风险可以理解为是利率下跌所导致债券价格下跌的风险<br>II．久期越短，利率变化时债券基金净值的波动幅度越小<br>III．不能采用买断式回购进行融资<br>IV．利率相对较低时，公司债券通常附有提前赎回条款",
            "question": "A．II、III\nB．I、IV\nC．I、III\nD．I、III、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于投资业绩评估，以下表述错误的是（　　）。",
            "question": "A．业绩度量是对投资组合收益率、风险等各类业绩指标的计算\nB．基金经理和投资者通过投资业务评估来考察投资目标的实现情况\nC．绩效评估是将投资组合的表现与业绩基准进行对比，做出评价\nD．业绩归因是将投资业绩与同类产品做对比分析并找到业绩改进的方法",
            "answer": "D",
            "explain": "基金的业绩归因是评估投资组合收益的原因或来源的技术，回答的是“收益从哪里来”这个问题，而不是和同类产品作比较。"
        },
        {
            "title": "关于投资组合管理的基本步骤，以下属于规划过程的是（　　）。",
            "questions": "I．确定并量化投资者的投资目标和投资限制<br>II．投资组合优化<br>III．制定投资政策说明书<br>IV．形成资本市场预期<br>V．业绩评估<br>VI．建立战略资产配置",
            "question": "A．I、II、IV、VI\nB．I、II、III、IV\nC．I、IV、V、VI\nD．I、III、IV、VI",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于计算风险价值(VAR)的历史模拟法，以下表述错误的是（　　）。",
            "question": "A．该方法假设市场未来的变化方向与市场的历史发展状况大致相同\nB．被认为是最精准贴近的计算方法\nC．以最近发生过的数据作为数据来源\nD．计算时无须在事先确定风险因子收益或概率分布，只需利用历史数据对未来方向进行估算",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "下面关于沪股通和港股通的说法正确的是（　　）。",
            "question": "A．所谓港股通，就是投资者委托内地证券服务公司，经由上海证券交易所设立的证券交易服务公司，向香港联合交易所进行申报，买卖规定范围上海证券交易所上市的股票\nB．所谓港股通，就是投资者委托香港经纪商，经由香港联合交易所设立的证券交易服务公司，向上海证券交易所进行申报，买卖规定范围内的上海证券交易所上市的股票\nC．所谓沪股通，就是投资者委托内地证券服务公司，经由上海证券交易所设立的证券交易服务公司，向香港联合交易所进行申报，买卖规定范围香港联合交易所上市的股票\nD．所谓沪股通，就是投资者委托香港经纪商，经由香港联合交易所设立的证券交易服务公司，向上海证券交易所进行申报，买卖规定范围内上海证券交易所上市的股票",
            "answer": "D",
            "explain": "本题考查沪股通和港股通。沪股通，就是投资者委托香港经纪商，经由香港联合交易所设立的证券交易服务公司，向上海证券交易所进行申报，买卖规定范围内上海证券交易所上市的股票。"
        },
        {
            "title": "下列选项中，不属于另类投资局限性的是（　　）。",
            "question": "A．与传统资产相关性差，不能够分散风险\nB．流动性较差，杠杆率偏高\nC．估值难度大，难以对资产价值进行准确评估\nD．缺乏监管和信息透明度",
            "answer": "A",
            "explain": "本题考查另类投资。另类投资的局限性包括：①缺乏监管和信息透明度；②流动性较差，杠杆率偏高；③估值难度大，难以对资产价值进行准确评估。另类投资的优点是：①提高收益；②分散风险。由于另类投资产品与传统证券投资产品具有较低的相关性，所以投资者能够通过另类投资产品达到分散投资风险的作用。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/11/jjjc-4.js